import styled from 'styled-components';

import { makeBoxShadows } from '../../styles';
import { BoxShadowProps } from './box-shadow';


type RootProps = {} & BoxShadowProps

const Root = styled.div<RootProps>`
	${p => makeBoxShadows(p.elevation)}
`;

export {
	Root
}
